import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import computer from "../../../assets/CampuLifeImages/hostel.JPG"
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'

const InfraHostel = () => {
  
  const libraryData = {
    img: computer,
    content: "Noorul Islam College of Arts & Science provides safe, comfortable, and well-maintained hostel accommodations for students. The hostels are equipped with essential amenities including furnished rooms, hygienic dining facilities, round-the-clock security, Wi-Fi connectivity, and recreational spaces to ensure a balanced and supportive living environment. Separate accommodations are available for male and female residents, with wardens and support staff ensuring proper upkeep and discipline."
  }

  return (
    <>
    <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
       <CampusSlashTitle slashTitle="Hostel" />
      <CampusDynamicSection data={libraryData} />
      </div>
      <Footer />
      </div>
      </div>
    </>
  )
}

export default InfraHostel